import { request } from '../client';

// The list's `products` are projected for the delivery geography (price,
// stock, outlet opt-outs); `ids` is the customer's full membership either way.
export const listFavourites = (options) => request('/favourites', { geographySensitive: true, ...options });

// Membership writes do not depend on geography.
export const addFavourite = (productId) => request(`/favourites/${productId}`, { method: 'POST' });

export const removeFavourite = (productId) => request(`/favourites/${productId}`, { method: 'DELETE' });
